import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsMobile, setScreenOrientation } from '../../store/selectors/global.selector';

function useUserDeviceAndScreenOrientationDetection() {
  const dispatch = useDispatch();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (
      /android|avantgo|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(40|60)|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        userAgent
      )
    ) {
      dispatch(setIsMobile(true));
    } else {
      dispatch(setIsMobile(false));
    }

    const checkOrientation = () => {
      if (window.orientation === 0 || window.orientation === 180) {
        dispatch(setScreenOrientation('PORTRAIT'));
      } else {
        dispatch(setScreenOrientation('LANDSCAPE'));
      }
    };

    window.addEventListener('orientationchange', checkOrientation);

    checkOrientation();

    return () => {
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, [navigator.userAgent]);

  return {};
}

export default useUserDeviceAndScreenOrientationDetection;
